import React from 'react';
import ForgotEmail from '../components/HomePage/ForgotEmail';
import Layout from '../layout';
import messages from '../i18n/en';

class IndexPage extends React.Component<any, any> {
  state = {
    isBrowser: true,
  };

  render() {
    return (
      <Layout
        keywords={`Esper Login, Esper SignUp, Free MDM Trail, Free Devops Software`}
        description={
          'In case you forgot your Endpoint URL, Enter your email and we’ll send you your unique endpoint name.'
        }
        messages={messages}
        fullScreen={true}
        title={'Forgot Your Endpoint? | Get reminded | Login to Esper'}
        className="first-page"
        location={this.props.location}
      >
        <ForgotEmail isDeveloper={true} />
      </Layout>
    );
  }
}

export default IndexPage;
